import Controller from 'controllers/controller';
import CarouselController from 'controllers/carousel';
import HappeningController from 'controllers/happening';

class HappeningsController extends Controller {
    constructor(app) {
        super(app);
        
        this.root = document.querySelector('.page[data-template="happenings"]');

        this.elements = { };
        this.controllers = [ ];
        this.carousel = null;

        this.app.loaderController.on('happenings-loaded', () => {
            this.cacheElements();
            this.initCarousel();
            this.initControllers();
        });
    }

    cacheElements() {
        this.elements.carousel = this.root.querySelector('.carousel');
        this.elements.happenings = Array.from(this.root.querySelectorAll('.slide-happening'));
    }

    initCarousel() {
        this.carousel = this.app.make(CarouselController, this.elements.carousel, {
            cellAlign: 'left',
            contain: true,
            groupCells: true
        });
    }
    
    initControllers() {
        this.elements.happenings.forEach(happening => {
            this.controllers.push(this.app.make(HappeningController, happening));
        });
    }
}

export default HappeningsController;